import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { verifySchoolCode, login } from "../../action/auth";
import { Redirect } from "react-router-dom";
import APP_CONSTANTS from "../../helper/APP_CONSTANTS";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Modal,
  UncontrolledAlert,
} from "reactstrap";

import { getQueryStringValue } from "../../utility.js";
import { arrayValidation } from "helper/validation";

const EmailPasswordCompo = (props) => {
  return (
    <>
      <FormGroup className="mb-3">
        <InputGroup className="input-group-alternative">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className="ni ni-email-83" />
            </InputGroupText>
          </InputGroupAddon>

          <Input
            onChange={(e) => props.handleChange(e, "email")}
            placeholder="Email"
            type="email"
            required
          />
        </InputGroup>
      </FormGroup>
      <FormGroup>
        <InputGroup className="input-group-alternative">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className="ni ni-lock-circle-open" />
            </InputGroupText>
          </InputGroupAddon>
          <Input
            onChange={(e) => props.handleChange(e, "password")}
            placeholder="Password"
            type={props.showPassword ? "text" : "password"}
            autoComplete="off"
            required
          />
          <InputGroupAddon addonType="prepend">
            <InputGroupText onClick={props.handleShowPassword}>
              {props.showPassword ? (
                <i class="fas fa-eye-slash"></i>
              ) : (
                <i className="fas fa-eye"></i>
              )}
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    </>
  );
};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      schoolVarified: false,
      schoolCode: "",
      email: "",
      password: "",
      notificationModal: false,
      disable: false,
      modalMessage: "",
      showPassword: false,
    };
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;

    const sch = getQueryStringValue("sc");

    if (sch) {
      this.setState(
        {
          schoolCode: sch,
        },
        () => {
          this.props.verifySchoolCode({
            data: {
              sch_code: sch,
            },
          });
        }
      );
    }
  }

  componentWillReceiveProps(newProp) {
    if (newProp.auth.status !== "201" && newProp.auth.status) {
      this.setState({
        notificationModal: true,
        modalMessage: newProp.auth.msg,
      });
    }

    if (newProp.school.status != "201")
      this.setState({
        notificationModal: true,
        // schoolVarified: false,
        disable: false,
        modalMessage: newProp.school.msg,
      });
    else {
      this.setState({
        notificationModal: false,
      });
    }

    if (newProp.school.status == "201") {
      this.setState({
        schoolVarified: true,
      });
    }
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  handleChange = (e, state) => {
    this.setState({
      [state]: e.target.value,
    });
  };

  handleShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.schoolVarified && this.state.schoolCode) {
      this.props.history.replace(
        this.props.location.pathname + "?sc=" + this.state.schoolCode
      );
      this.props.verifySchoolCode({
        data: {
          sch_code: this.state.schoolCode,
        },
      });
      return;
    }

    this.setState({
      notificationModal: false,
      modalMessage: "",
    });

    const { email, password, schoolCode } = this.state;
    if (!email || !password) {
      alert("Fill all detail");
      return;
    }

    this.props.login({
      data: { email: email, sch_code: schoolCode, password: btoa(password) },
    });
  };

  render() {
    const isRestrictAccess =
      arrayValidation(this.props.auth.master) &&
      this.props.auth.master[0].access_type === "93";

    console.log("datadata master", this.props.school, this.props.auth);

    if (this.props.auth.isLogin) {
      const { from } = this.props.location.state || {
        from: { pathname: isRestrictAccess ? "/survey" : "/" },
      };

      if (this.props.auth.isLogin) {
        return <Redirect to={from} />;
      }
    }

    return (
      <>
        <main ref="main">
          <section
            style={{ height: "100vh" }}
            className="section section-shaped section-lg"
          >
            <div className="shape shape-style-1 bg-gradient-default">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <Container className="pt-lg-2">
              <Row className="d-flex justify-content-center">
                <Col lg="5">
                  {this.state.notificationModal &&
                    !!this.state.modalMessage && (
                      <UncontrolledAlert color="danger">
                        <span className="alert-inner--text">
                          {this.state.modalMessage}
                        </span>
                      </UncontrolledAlert>
                    )}
                  <div
                    style={{
                      maxWidth: "420px",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }}
                  >
                    <Card
                      className="bg-secondary shadow border-0"
                      style={{
                        maxWidth: "400px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <CardHeader className="bg-white py-3 ">
                        <div className="text-muted text-center ">Sign in</div>
                      </CardHeader>
                      <CardBody className="px-lg-5 py-lg-5">
                        <Form onSubmit={this.handleSubmit} role="form">
                          <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-badge" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                disabled={this.state.schoolVarified}
                                onChange={(e) =>
                                  this.handleChange(e, "schoolCode")
                                }
                                value={this.state.schoolCode}
                                placeholder="School code"
                                type="text"
                              />
                            </InputGroup>
                          </FormGroup>

                          {this.state.schoolVarified ? (
                            <EmailPasswordCompo
                              handleChange={this.handleChange}
                              showPassword={this.state.showPassword}
                              handleShowPassword={this.handleShowPassword}
                            />
                          ) : null}

                          <div className="text-center">
                            <Button className="" color="primary" type="submit">
                              Sign in
                            </Button>
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                    <Row className="mt-3 text-left">
                      <Col lg="5">
                        <a
                          className="text-light"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          <small>Forgot password?</small>
                        </a>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
            <div
              className="d-flex justify-content-center flex-column text-center mt-3"
              style={{
                position: "absolute",
                bottom: "0px",
                left: "0px",
                right: "0px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <span style={{ color: "#fff" }}>
                &copy; 2017-{new Date().getFullYear()} Empass Learning Private
                Limited. All Rights Reserved
              </span>

              <p className="contact-help-container">
  <a
    rel="noreferrer noopener"
    target="_blank"
    href={APP_CONSTANTS.TERMS_OF_SERVICES_URL}
    className="link"
    style={{ marginRight: "15px", color: "white" }}
  >
    Terms of Service
  </a>
  <span style={{ color: "white", margin: "0 10px" }}>|</span> 
  
  <a
    rel="noreferrer noopener"
    target="_blank"
    href={APP_CONSTANTS.PRIVACY_POLICY_URL}
    style={{ marginRight: "15px",marginLeft: "15px", color: "white" }}
  >
    Privacy Policy
  </a>
  <span style={{ color: "white", margin: "0 10px" }}>|</span> 
  
  <a
    rel="noreferrer noopener"
    target="_blank"
    href={APP_CONSTANTS.CONTACT_US_URL}
    style={{ marginLeft: "15px", color: "white" }}
  >
    Contact us
  </a>
</p>


            </div>
          </section>
        </main>
      </>
    );
  }
}

const propState = (store) => {
  return {
    school: store.schoolCode,
    auth: store.auth,
  };
};

const propAction = (dispatch) => {
  return {
    verifySchoolCode: (data) => dispatch(verifySchoolCode(data)),
    login: (data) => dispatch(login(data)),
  };
};

export default connect(propState, propAction)(Login);
